// Transcribed from Appendix A of the supplied Ørsted instruction, DOC-005439 v4,
// approved 13 December 2024. Values 6, 8 and 9 have no verbal anchor there.
export const ORSTED_RPE_QUESTION = 'On a scale from 0-10, how do you perceive the level of physical exertion right now?';
export const ORSTED_RPE_SCALE = [
  { value: 0, label: 'Nothing at all' },
  { value: 1, label: 'Very light' },
  { value: 2, label: 'Fairly light' },
  { value: 3, label: 'Moderate' },
  { value: 4, label: 'Somewhat hard' },
  { value: 5, label: 'Hard' },
  { value: 6, label: '' },
  { value: 7, label: 'Very hard' },
  { value: 8, label: '' },
  { value: 9, label: '' },
  { value: 10, label: 'Very, very hard' },
] as const;

// Beeline educational cues supplement the original anchors; they are examples,
// not a separately validated scale or a way to infer a patient's rating from HR.
export const RPE_PATIENT_CUES = [
  'Resting. Breathing normally; no effort in your legs or body.',
  'Barely any effort. Breathing feels normal; talking is effortless.',
  'Easy movement. You notice your legs working a little; conversation is easy.',
  'A steady effort. Breathing is a little deeper; you can speak comfortably in full sentences.',
  'Working noticeably. Breathing is faster and your legs feel the work; talking takes a little more effort.',
  'Hard work. Breathing is deep and faster; you need pauses between sentences.',
  'Harder than 5. Your legs feel tired and you prefer short sentences to a conversation.',
  'Very demanding. Breathing is heavy; you can manage only a few words before a breath.',
  'Harder than 7. Breathing and leg effort feel very intense; speaking is difficult. Tell the examiner now.',
  'Almost your greatest possible effort. Talking is very difficult and you feel close to your limit.',
  'Your greatest possible effort. You feel at your limit and unable to keep going.',
] as const;
export const RPE_PATIENT_GUIDE = ORSTED_RPE_SCALE.map((entry, index) => ({
  ...entry,
  description: RPE_PATIENT_CUES[index],
}));
export const RPE_HONEST_PROMPT = 'Rate how your whole body feels right now: your breathing, tired legs and overall effort. Choose your own number, not the number you think the examiner wants. These examples are guides; you do not need to match every detail.';
export const RPE_STOP_PROMPT = 'Tell the examiner straight away if you have chest discomfort, feel dizzy, unusually breathless or unwell, whatever your number. You do not need to reach the top of the scale. The examiner may stop the test earlier.';
